import * as angular from "angular";
import {IController} from "angular";

export class SitesTableRowCtrl implements IController {
  sitesTableCtrl: IController;
  site: any;

  constructor() {
  }
}

angular
  .module('bringoz.admin.organizations')
  .component('sitesTableRow', {
    require: {
      sitesTableCtrl: '^sitesTable'
    },
    bindings: {
      site: '<'
    },
    template: require('./sites-table-row.html').default,
    controller: SitesTableRowCtrl
  });
